










































































































































import { Component, Prop, Vue, Provide } from "vue-property-decorator";

@Component
export default class DesktopMenu extends Vue {
  @Prop() private msg!: string;
  @Provide() accountType = "";
  change() {
    this.msg = "";
  }
  goto(page: string) {
    if (page == "Travel Plan Maps") {
      this.$router.push({
        name: "Travel Plan Maps",
        params: { category: "modes_of_travel_map" },
      });
    } else {
      this.$router.push({ name: page });
    }
  }
  gotoPath(path: string) {
    this.$router.push(path);
  }
  get logo() {
    if (this.accountType !== "SUPERADMIN") {
      if (this.$store.state.user.admin_organization) {
        return this.$store.state.user.admin_organization.logo_url;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  get unread() {
    return this.$store.state.unread_messages;
  }
  get domainName() {
    if (!this.$store.state.user) {
      return null;
    }
    if (this.$store.state.user.admin_organization) {
      return this.$store.state.user.admin_organization?.name;
    } else {
      return this.$store.state.user.admin_organization?.name;
    }
  }

  get currentRoute() {
    return this.$route.path;
  }
  setAccountType() {
    const adminRoles = this.$store.state.user.admin_roles;
    if (adminRoles.length > 0) {
      this.accountType = adminRoles[0].slug;
    }
  }
  mounted() {
    this.setAccountType();
  }
}
